import {Button, DialogActions, DialogContent, DialogTitle, Paper} from '@mui/material';
import React from 'react';
import { DialogProps } from '../DialogProps';
import { IEmployee } from '../../../Interfaces/Admin/IEmployee';
import {
  IApplicationChecklistHistory
} from "../../../Interfaces/Application/IApplicationChecklistHistory";
import {getEmployeeName} from "../../../utils/utils";
import { hasValue } from "@amsanalytics/react-shared-library";
import styles from './_application-checklist-history-dialog.module.scss';

// Style classes.
// const useStyles: any = makeStyles({
//   container: {
//     display: 'flex',
//     flexWrap: 'wrap',
//     margin: '5px 0',
//     padding: '1rem',
//     fontSize: '14px',
//   },
//   cardHeader: {
//     fontSize: '1.1em',
//     fontWeight: 'bold',
//   },
//   sectionTitle: {
//     fontWeight: 600,
//   },
//   gridContent: {
//     margin: '5px 20px 0 0',
//   },
// });

export interface ApplicationChecklistHistoryDialogProps extends DialogProps<null> {
  applicationChecklistHistories: IApplicationChecklistHistory[];
  employees: IEmployee[];
  checklistName: string;
}

export default function ApplicationChecklistHistoryDialog(props: ApplicationChecklistHistoryDialogProps) {
  // Get styles for this dialog.


  return (
    <>
      <DialogTitle style={{ cursor: 'move' }} id='draggable-dialog-title'>
        {`History for the ${props.checklistName} Checklist`}
      </DialogTitle>
      <DialogContent>
        {
          props.applicationChecklistHistories.length === 0 && <DialogContent><p>There is no history to show.</p></DialogContent>
        }
        {
          props.applicationChecklistHistories.map((ach, key: number) => {
            const createdByName = hasValue(ach.createdBy) ? getEmployeeName(props.employees, ach.createdBy) : "";
            const approvedBy = hasValue(ach.approvedBy) ? getEmployeeName(props.employees, ach.approvedBy) : "";
            
            return (
              <Paper
                key={key}
                elevation={3}
                className={styles.applicationChecklistContainer}
              >
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-betweeen' }}>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Modified By:</span>
                      &nbsp;
                      {createdByName}
                    </div>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Modified On:</span>
                      &nbsp;
                      {ach.createdDate && new Date(ach.createdDate).toLocaleString()}
                    </div>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Approved By:</span>
                      &nbsp;
                      {approvedBy}
                    </div>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Approved Date:</span>
                      &nbsp;
                      {ach.approvedDate && new Date(ach.approvedDate).toLocaleString()}
                    </div>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Approver's Signature:</span>
                      &nbsp;
                      {ach.approversSignature}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-betweeen' }}>
                    <div className={styles.gridContent}>
                      <span className={styles.sectionTitle}>Checklist Note:</span>
                      &nbsp;
                      {ach.checklistComment}
                    </div>
                  </div>
                </div>
              </Paper>
            );
          })
        }
      </DialogContent >
      <DialogActions>
        <Button autoFocus onClick={props.closeDialog} color='primary'>
          Close
        </Button>
      </DialogActions>
    </>
  );
}
